export default {
  getInitials(name, surname) {
    return `${name.charAt(0) || ""}${surname.charAt(0) || ""}`;
  },
  getFullNameInitials(name) {
    var name = name.split(" ");
    return `${name[0].charAt(0) || ""}${name[1].charAt(0) || ""}`;
  },
  languageDropdown() {
    return [
      {
        text: "English",
        value: "en",
      },
      {
        text: "Srpski",
        value: "srb",
      },
      {
        text: "Italiano",
        value: "it",
      },
      {
        text: "中文",
        value: "zh",
      },
      {
        text: "Deutsch",
        value: "de",
      },
    ];
  },
  getAvatarProfile(gender, isHuman) {
    if (isHuman) {
      if (gender == "Male") {
        return require("@/assets/images/avatars/male_avatar.jpeg");
      } else if (gender == "Female") {
        return require("@/assets/images/avatars/female_avatar.jpeg");
      } else {
        return require("@/assets/images/avatars/other_avatar.jpeg");
      }
    } else {
      return require("@/assets/images/avatars/pet_avatar.png");
    }
  },
  countries() {
    return [
      { text: "Afghanistan", value: "AF", continent: "Asia" },
      { text: "Albania", value: "AL", continent: "Europe" },
      { text: "Algeria", value: "DZ", continent: "Africa" },
      { text: "Andorra", value: "AD", continent: "Europe" },
      { text: "Angola", value: "AO", continent: "Africa" },
      { text: "Antigua and Barbuda", value: "AG", continent: "North America" },
      { text: "Argentina", value: "AR", continent: "South America" },
      { text: "Armenia", value: "AM", continent: "Asia" },
      { text: "Australia", value: "AU", continent: "Oceania" },
      { text: "Austria", value: "AT", continent: "Europe" },
      { text: "Azerbaijan", value: "AZ", continent: "Asia" },
      { text: "Bahamas", value: "BS", continent: "North America" },
      { text: "Bahrain", value: "BH", continent: "Asia" },
      { text: "Bangladesh", value: "BD", continent: "Asia" },
      { text: "Barbados", value: "BB", continent: "North America" },
      { text: "Belarus", value: "BY", continent: "Europe" },
      { text: "Belgium", value: "BE", continent: "Europe" },
      { text: "Belize", value: "BZ", continent: "North America" },
      { text: "Benin", value: "BJ", continent: "Africa" },
      { text: "Bhutan", value: "BT", continent: "Asia" },
      { text: "Bolivia", value: "BO", continent: "South America" },
      { text: "Bosnia and Herzegovina", value: "BA", continent: "Europe" },
      { text: "Botswana", value: "BW", continent: "Africa" },
      { text: "Brazil", value: "BR", continent: "South America" },
      { text: "Brunei", value: "BN", continent: "Asia" },
      { text: "Bulgaria", value: "BG", continent: "Europe" },
      { text: "Burkina Faso", value: "BF", continent: "Africa" },
      { text: "Burundi", value: "BI", continent: "Africa" },
      { text: "Cabo Verde", value: "CV", continent: "Africa" },
      { text: "Cambodia", value: "KH", continent: "Asia" },
      { text: "Cameroon", value: "CM", continent: "Africa" },
      { text: "Canada", value: "CA", continent: "North America" },
      { text: "Central African Republic", value: "CF", continent: "Africa" },
      { text: "Chad", value: "TD", continent: "Africa" },
      { text: "Chile", value: "CL", continent: "South America" },
      { text: "China", value: "CN", continent: "Asia" },
      { text: "Colombia", value: "CO", continent: "South America" },
      { text: "Comoros", value: "KM", continent: "Africa" },
      {
        text: "Congo, Democratic Republic of the",
        value: "CD",
        continent: "Africa",
      },
      { text: "Congo, Republic of the", value: "CG", continent: "Africa" },
      { text: "Costa Rica", value: "CR", continent: "North America" },
      { text: "Croatia", value: "HR", continent: "Europe" },
      { text: "Cuba", value: "CU", continent: "North America" },
      { text: "Cyprus", value: "CY", continent: "Asia" },
      { text: "Czech Republic", value: "CZ", continent: "Europe" },
      { text: "Denmark", value: "DK", continent: "Europe" },
      { text: "Djibouti", value: "DJ", continent: "Africa" },
      { text: "Dominica", value: "DM", continent: "North America" },
      { text: "Dominican Republic", value: "DO", continent: "North America" },
      { text: "Ecuador", value: "EC", continent: "South America" },
      { text: "Egypt", value: "EG", continent: "Africa" },
      { text: "El Salvador", value: "SV", continent: "North America" },
      { text: "Equatorial Guinea", value: "GQ", continent: "Africa" },
      { text: "Eritrea", value: "ER", continent: "Africa" },
      { text: "Estonia", value: "EE", continent: "Europe" },
      { text: "Eswatini", value: "SZ", continent: "Africa" },
      { text: "Ethiopia", value: "ET", continent: "Africa" },
      { text: "Fiji", value: "FJ", continent: "Oceania" },
      { text: "Finland", value: "FI", continent: "Europe" },
      { text: "France", value: "FR", continent: "Europe" },
      { text: "Gabon", value: "GA", continent: "Africa" },
      { text: "Gambia", value: "GM", continent: "Africa" },
      { text: "Georgia", value: "GE", continent: "Asia" },
      { text: "Germany", value: "DE", continent: "Europe" },
      { text: "Ghana", value: "GH", continent: "Africa" },
      { text: "Greece", value: "GR", continent: "Europe" },
      { text: "Grenada", value: "GD", continent: "North America" },
      { text: "Guatemala", value: "GT", continent: "North America" },
      { text: "Guinea", value: "GN", continent: "Africa" },
      { text: "Guinea-Bissau", value: "GW", continent: "Africa" },
      { text: "Guyana", value: "GY", continent: "South America" },
      { text: "Haiti", value: "HT", continent: "North America" },
      { text: "Honduras", value: "HN", continent: "North America" },
      { text: "Hungary", value: "HU", continent: "Europe" },
      { text: "Iceland", value: "IS", continent: "Europe" },
      { text: "India", value: "IN", continent: "Asia" },
      { text: "Indonesia", value: "ID", continent: "Asia" },
      { text: "Iran", value: "IR", continent: "Asia" },
      { text: "Iraq", value: "IQ", continent: "Asia" },
      { text: "Ireland", value: "IE", continent: "Europe" },
      { text: "Israel", value: "IL", continent: "Asia" },
      { text: "Italy", value: "IT", continent: "Europe" },
      { text: "Jamaica", value: "JM", continent: "North America" },
      { text: "Japan", value: "JP", continent: "Asia" },
      { text: "Jordan", value: "JO", continent: "Asia" },
      { text: "Kazakhstan", value: "KZ", continent: "Asia" },
      { text: "Kenya", value: "KE", continent: "Africa" },
      { text: "Kiribati", value: "KI", continent: "Oceania" },
      { text: "Korea, North", value: "KP", continent: "Asia" },
      { text: "Korea, South", value: "KR", continent: "Asia" },
      { text: "Kuwait", value: "KW", continent: "Asia" },
      { text: "Kyrgyzstan", value: "KG", continent: "Asia" },
      { text: "Laos", value: "LA", continent: "Asia" },
      { text: "Latvia", value: "LV", continent: "Europe" },
      { text: "Lebanon", value: "LB", continent: "Asia" },
      { text: "Lesotho", value: "LS", continent: "Africa" },
      { text: "Liberia", value: "LR", continent: "Africa" },
      { text: "Libya", value: "LY", continent: "Africa" },
      { text: "Liechtenstein", value: "LI", continent: "Europe" },
      { text: "Lithuania", value: "LT", continent: "Europe" },
      { text: "Luxembourg", value: "LU", continent: "Europe" },
      { text: "Madagascar", value: "MG", continent: "Africa" },
      { text: "Malawi", value: "MW", continent: "Africa" },
      { text: "Malaysia", value: "MY", continent: "Asia" },
      { text: "Maldives", value: "MV", continent: "Asia" },
      { text: "Mali", value: "ML", continent: "Africa" },
      { text: "Malta", value: "MT", continent: "Europe" },
      { text: "Marshall Islands", value: "MH", continent: "Oceania" },
      { text: "Mauritania", value: "MR", continent: "Africa" },
      { text: "Mauritius", value: "MU", continent: "Africa" },
      { text: "Mexico", value: "MX", continent: "North America" },
      { text: "Micronesia", value: "FM", continent: "Oceania" },
      { text: "Moldova", value: "MD", continent: "Europe" },
      { text: "Monaco", value: "MC", continent: "Europe" },
      { text: "Mongolia", value: "MN", continent: "Asia" },
      { text: "Montenegro", value: "ME", continent: "Europe" },
      { text: "Morocco", value: "MA", continent: "Africa" },
      { text: "Mozambique", value: "MZ", continent: "Africa" },
      { text: "Myanmar", value: "MM", continent: "Asia" },
      { text: "Namibia", value: "NA", continent: "Africa" },
      { text: "Nauru", value: "NR", continent: "Oceania" },
      { text: "Nepal", value: "NP", continent: "Asia" },
      { text: "Netherlands", value: "NL", continent: "Europe" },
      { text: "New Zealand", value: "NZ", continent: "Oceania" },
      { text: "Nicaragua", value: "NI", continent: "North America" },
      { text: "Niger", value: "NE", continent: "Africa" },
      { text: "Nigeria", value: "NG", continent: "Africa" },
      { text: "North Macedonia", value: "MK", continent: "Europe" },
      { text: "Norway", value: "NO", continent: "Europe" },
      { text: "Oman", value: "OM", continent: "Asia" },
      { text: "Pakistan", value: "PK", continent: "Asia" },
      { text: "Palau", value: "PW", continent: "Oceania" },
      { text: "Palestine", value: "PS", continent: "Asia" },
      { text: "Panama", value: "PA", continent: "North America" },
      { text: "Papua New Guinea", value: "PG", continent: "Oceania" },
      { text: "Paraguay", value: "PY", continent: "South America" },
      { text: "Peru", value: "PE", continent: "South America" },
      { text: "Philippines", value: "PH", continent: "Asia" },
      { text: "Poland", value: "PL", continent: "Europe" },
      { text: "Portugal", value: "PT", continent: "Europe" },
      { text: "Qatar", value: "QA", continent: "Asia" },
      { text: "Romania", value: "RO", continent: "Europe" },
      { text: "Russia", value: "RU", continent: "Europe" },
      { text: "Rwanda", value: "RW", continent: "Africa" },
      {
        text: "Saint Kitts and Nevis",
        value: "KN",
        continent: "North America",
      },
      { text: "Saint Lucia", value: "LC", continent: "North America" },
      {
        text: "Saint Vincent and the Grenadines",
        value: "VC",
        continent: "North America",
      },
      { text: "Samoa", value: "WS", continent: "Oceania" },
      { text: "San Marino", value: "SM", continent: "Europe" },
      { text: "Sao Tome and Principe", value: "ST", continent: "Africa" },
      { text: "Saudi Arabia", value: "SA", continent: "Asia" },
      { text: "Senegal", value: "SN", continent: "Africa" },
      { text: "Serbia", value: "RS", continent: "Europe" },
      { text: "Seychelles", value: "SC", continent: "Africa" },
      { text: "Sierra Leone", value: "SL", continent: "Africa" },
      { text: "Singapore", value: "SG", continent: "Asia" },
      { text: "Slovakia", value: "SK", continent: "Europe" },
      { text: "Slovenia", value: "SI", continent: "Europe" },
      { text: "Solomon Islands", value: "SB", continent: "Oceania" },
      { text: "Somalia", value: "SO", continent: "Africa" },
      { text: "South Africa", value: "ZA", continent: "Africa" },
      { text: "South Sudan", value: "SS", continent: "Africa" },
      { text: "Spain", value: "ES", continent: "Europe" },
      { text: "Sri Lanka", value: "LK", continent: "Asia" },
      { text: "Sudan", value: "SD", continent: "Africa" },
      { text: "Suriname", value: "SR", continent: "South America" },
      { text: "Sweden", value: "SE", continent: "Europe" },
      { text: "Switzerland", value: "CH", continent: "Europe" },
      { text: "Syria", value: "SY", continent: "Asia" },
      { text: "Taiwan", value: "TW", continent: "Asia" },
      { text: "Tajikistan", value: "TJ", continent: "Asia" },
      { text: "Tanzania", value: "TZ", continent: "Africa" },
      { text: "Thailand", value: "TH", continent: "Asia" },
      { text: "Timor-Leste", value: "TL", continent: "Asia" },
      { text: "Togo", value: "TG", continent: "Africa" },
      { text: "Tonga", value: "TO", continent: "Oceania" },
      { text: "Trinidad and Tobago", value: "TT", continent: "North America" },
      { text: "Tunisia", value: "TN", continent: "Africa" },
      { text: "Turkey", value: "TR", continent: "Asia" },
      { text: "Turkmenistan", value: "TM", continent: "Asia" },
      { text: "Tuvalu", value: "TV", continent: "Oceania" },
      { text: "Uganda", value: "UG", continent: "Africa" },
      { text: "Ukraine", value: "UA", continent: "Europe" },
      { text: "United Arab Emirates", value: "AE", continent: "Asia" },
      { text: "United Kingdom", value: "GB", continent: "Europe" },
      { text: "United States", value: "US", continent: "North America" },
      { text: "Uruguay", value: "UY", continent: "South America" },
      { text: "Uzbekistan", value: "UZ", continent: "Asia" },
      { text: "Vanuatu", value: "VU", continent: "Oceania" },
      { text: "Vatican City", value: "VA", continent: "Europe" },
      { text: "Venezuela", value: "VE", continent: "South America" },
      { text: "Vietnam", value: "VN", continent: "Asia" },
      { text: "Yemen", value: "YE", continent: "Asia" },
      { text: "Zambia", value: "ZM", continent: "Africa" },
      { text: "Zimbabwe", value: "ZW", continent: "Africa" },
    ];
  },
};
